// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2Otvm","actionsCol":"EnrolledClinics_actionsCol__3Lhet"};